// import store from '../store'
import moment from 'moment'

export const wtMerchants = [
    {
        id: 123456789,
        name: 'Sklep 1',
        city: 'Warszawa',
        street: 'Leśna',
        number: '11',
        postcode: '12-345',
        state: 'active',
        fullAddress: 'ul. Leśna 11, 12-345 Warszawa'
    },
    {
        id: 223456789,
        name: 'Sklep 2',
        city: 'Warszawa',
        street: 'Słoneczna',
        number: '22',
        postcode: '12-345',
        state: 'active',
        fullAddress: 'ul. Słoneczna 22, 12-345 Warszawa'
    }
]

export const wtNewPromoForm = {
    step1: {
        end_at: {
            value: moment()
                .add(1, 'month')
                .format('YYYY-MM-DD HH:mm:ss')
        },
        loyalty: {
            value: true
        },
        name: {
            value: 'Promocja samouczkowa'
        },
        start_at: {
            value: moment().format('YYYY-MM-DD HH:mm:ss')
        },
        type: {
            value: 'Promo::WeightPeriodicPriceReduction'
        },
        usage_limit_per_receipt: {
            value: ''
        },
        marketing_id: 1
    },
    step2: {
        merchants: {
            value: [wtMerchants[1]]
        }
    },
    step3: {
        main_image_dict_product_id: {
            value: null
        },
        product_sets: {
            price: {
                value: []
            },
            products: {
                value: []
            }
        },
        products: {
            value: []
        }
    }
}

export const wtNetworkLimits = [
    {
        active_promotions: 10,
        merchant_id: 123456789,
        network_id: 2,
        retailer_promo_products_limit: 100,
        retailer_promos_limit: 10
    },
    {
        active_promotions: 0,
        merchant_id: 223456789,
        network_id: 2,
        retailer_promo_products_limit: 100,
        retailer_promos_limit: 10
    }
]

export const dictProducts = [
    {
        promo_dict_product_id: 3294,
        id: 454461,
        name: 'ZIEMNIAK MŁODY KG',
        main: true,
        ean: '2429200000005',
        image: {
            urls: {
                big: '/img/wtData/ziemniak-mlody.png',
                small: '/img/wtData/ziemniak-mlody.png',
                medium: '/img/wtData/ziemniak-mlody.png',
                original: '/img/wtData/ziemniak-mlody.png'
            }
        }
    },
    {
        promo_dict_product_id: 3293,
        id: 321158,
        name: 'ZIEMNIAK JADALNY KG',
        main: true,
        ean: '2428800000002',
        image: {
            urls: {
                big: '/img/wtData/ziemniak-mlody.png',
                small: '/img/wtData/ziemniak-mlody.png',
                medium: '/img/wtData/ziemniak-mlody.png',
                original: '/img/wtData/ziemniak-mlody.png'
            }
        }
    },
    {
        promo_dict_product_id: 3391,
        id: 455629,
        name: 'ZIEMNIAKI WCZESNE KG',
        main: true,
        ean: '20815745',
        image: {
            urls: {
                big: '/img/wtData/ziemniaki-wczesne.png',
                small: '/img/wtData/ziemniaki-wczesne.png',
                medium: '/img/wtData/ziemniaki-wczesne.png',
                original: '/img/wtData/ziemniaki-wczesne.png'
            }
        }
    }
]

export const dictProductsPagination = {
    page: 1,
    perPage: 10,
    totalPages: 1,
    totalRecords: 2
}

export const processedSubs = {
    accepted: {
        pagination: {
            nextPage: '',
            page: 1,
            perPage: '10',
            prevPage: '',
            totalPages: 1,
            totalRecords: 1
        },
        promos: [
            {
                group_id: 1,
                id: 123123,
                merchant_id: 123456789,
                name: 'Promocja samouczkowa',
                subscription_id: 123321,
                type: 'Promo::WeightPeriodicPriceReduction'
            }
        ],
        status: 'idle'
    },
    error: {
        pagination: null,
        promos: null,
        status: 'idle'
    },
    interrupted: {
        pagination: null,
        promos: null,
        status: 'idle'
    },
    total: 1
}

export const products = [
    {
        promotional: true,
        id: 11,
        maximum_price: 11.5,
        dict_product: {
            name: 'Produkt samouczkowy',
            ean: '1234567899876543',
            image: {
                urls: {
                    small: require('@/assets/logo-ep.svg')
                }
            }
        },
        image: {
            urls: {
                small: require('@/assets/logo-ep.svg')
            }
        },
        main: true,
        name: 'Produkt samouczkowy',
        ean: '1234567899876543',
        downloadLabel: true
    }
]

export const subscriptions = [
    {
        checked: true,
        company_merchant_status: 'active',
        id: 1111111,
        merchant_id: 123456789,
        state: 'available',
        status: 'available',
        updated_at: '2021-07-23T17:10:21.784+02:00',
        products
    },
    {
        checked: true,
        company_merchant_status: 'active',
        id: 1111112,
        merchant_id: 223456789,
        state: 'available',
        status: 'available',
        updated_at: '2021-07-23T17:10:21.784+02:00',
        products
    }
]
export const samplePromosData = {
    groupId: 1,
    id: 1,
    eanConflict: false,
    favorite: true,
    end_at: '2022-08-31T23:59:00.000+02:00',
    logo: {
        urls: {
            small: require('@/assets/logo-ep.svg'),
            medium: require('@/assets/logo-ep.svg')
        }
    },
    name: 'Promocja samouczkowa 1',
    start_at: '2021-07-23T17:20:00.000+02:00',
    products,
    productsPagination: { totalRecords: 1 },
    product_sets: [],
    subscriptions,
    main_set: true,
    selected: true,
    subscriptionsEqualPrices: {
        equalPrices: true,
        priceGroups: [subscriptions]
    },

    minimum_amount_of_refund: '0.51',
    type: 'Promo::PeriodicPriceReduction',
    selectedToGenerateLabels: true
}

export const wtPromoGroups = [
    {
        name: 'Przykładowa grupa zamknięta',
        acceptance: 'all',
        countPromos: 2,
        id: 1,
        selectWholeGroupButtonEnable: true,
        pagination: {
            totalRecords: 2
        },
        selectedPromoIds: [],
        selectWholeGroup: false,
        showPromosOnAcceptView: false,
        promos: [
            samplePromosData,
            Object.assign(
                { ...samplePromosData },
                {
                    id: 2,
                    name: 'Promocja samouczkowa 2',
                    type: 'Promo::RegularPrice'
                }
            )
        ]
    },
    {
        name: 'Przykładowa grupa otwarta',
        acceptance: 'any',
        countPromos: 2,
        id: 2,
        selectWholeGroupButtonEnable: true,
        pagination: {
            totalRecords: 2
        },
        selectedPromoIds: [],
        selectWholeGroup: false,
        showPromosOnAcceptView: false,
        promos: [
            Object.assign(
                { ...samplePromosData },
                {
                    id: 3,
                    name: 'Promocja samouczkowa 3',
                    type: 'Promo::RegularPrice'
                }
            ),
            Object.assign(
                { ...samplePromosData },
                {
                    id: 4,
                    name: 'Promocja samouczkowa 4'
                }
            )
        ]
    }
]

export const wtQueue = {
    accepted: {
        count: 2,
        promos: [
            {
                group_id: 1,
                id: 1,
                subscription_id: 1111111
            },
            {
                group_id: 1,
                id: 2,
                subscription_id: 1111112
            }
        ]
    },
    error: {
        count: 2,
        promos: [
            {
                description: '',
                detail: {
                    error: 'rejected_at_period'
                },
                id: 3,
                name: 'Promocja samouczkowa 3',
                subscription_id: 2222221,
                label: 'interrupted'
            },
            {
                description: '',
                detail: {
                    error: 'rejected_at_period'
                },
                id: 4,
                name: 'Promocja samouczkowa 4',
                subscription_id: 2222222,
                label: 'interrupted'
            }
        ]
    },
    all: 4,
    waiting: {
        count: 0
    }
}

export const wtAccepted = [
    {
        id: 1111111,
        subscription_id: 1111111,
        group_id: 1,
        promo_id: 1,
        name: 'Promocja samouczkowa 1',
        type: 'Promo::PeriodicPriceReduction',
        merchant_id: 123456789
    },
    {
        id: 1111112,
        subscription_id: 1111112,
        group_id: 1,
        promo_id: 2,
        name: 'Promocja samouczkowa 2',
        type: 'Promo::RegularPrice',
        merchant_id: 123456789
    }
]

export const wtConflicted = [
    {
        id: 2222221,
        promo_id: 3,
        name: 'Promocja samouczkowa 3',
        merchant_id: 223456789,
        detail: {
            error: 'rejected_at_period'
        },
        label: 'interrupted',
        description: ''
    },
    {
        id: 2222222,
        promo_id: 4,
        name: 'Promocja samouczkowa 4',
        merchant_id: 223456789,
        detail: {
            error: 'rejected_at_period'
        },
        label: 'interrupted',
        description: ''
    }
]

export const wtLabelGroups = [
    {
        name: 'Przykładowa grupa zamknięta',
        acceptance: 'all',
        id: 1,
        pagination: {
            totalRecords: 2
        },
        showPromosOnLabelsGenerateView: true,
        selectedPromoIds: [1, 2],
        promos: [
            samplePromosData,
            Object.assign(
                { ...samplePromosData },
                {
                    id: 2,
                    name: 'Promocja samouczkowa 2',
                    type: 'Promo::RegularPrice'
                }
            )
        ]
    }
]
